import { ModalConfig } from '@shared/interfaces/modal/modal-config';
import {
  MeterframeAddConversionFactorComponent
} from '@shared/modals/meterframe/meterframe-add-conversion-factor/meterframe-add-conversion-factor.component';

export const meterframeAddConversionFactorModalConfig: ModalConfig = {
  component: MeterframeAddConversionFactorComponent,
  title: 'conversionFactorModal.title',
  actions: [
    {
      type: 'primary',
      label: 'system.button.save',
      method: 'submit',
    },
    {
      type: 'secondary',
      label: 'system.button.cancel',
      closeOnClick: true,
    },
  ],
};
